import type { ScreeningStatus } from '@seans/contracts';

/**
 * Every TanStack Query key in the app. Keys are hierarchical so a mutation can invalidate a whole
 * family (`assets.all()`) or one entry (`assets.detail(id)`).
 */
export const queryKeys = {
  session: () => ['session'] as const,
  serverTime: () => ['server-time'] as const,
  accounts: {
    all: () => ['accounts'] as const,
    list: () => ['accounts', 'list'] as const,
  },
  accountInvitation: (token: string) => ['account-invitation', token] as const,
  assets: {
    all: () => ['assets'] as const,
    list: () => ['assets', 'list'] as const,
    detail: (assetId: string) => ['assets', 'detail', assetId] as const,
  },
  screenings: {
    all: () => ['screenings'] as const,
    list: (status: ScreeningStatus) => ['screenings', 'list', status] as const,
    detail: (screeningId: string) => ['screenings', 'detail', screeningId] as const,
    admissions: (screeningId: string) => ['screenings', 'admissions', screeningId] as const,
  },
  invites: () => ['invite'] as const,
  invite: (code: string) => ['invite', code] as const,
  room: {
    all: (screeningId: string) => ['room', screeningId] as const,
    snapshot: (screeningId: string) => ['room', screeningId, 'snapshot'] as const,
    chatHistory: (screeningId: string) => ['room', screeningId, 'chat-history'] as const,
  },
} as const;
